import { useEffect, useState } from "react";

type ResearchContract = {
  candidate_id: string;
  rule_id: string;
  family_id: string;
  trade_permission: string;
  contract_sha256: string;
  notice: string;
  measurement: { entry?: string; primary_outcome?: string; horizon_event?: string };
};

export default function ResearchContractCatalog({ token, onClose }: { token: string; onClose: () => void }) {
  const [rows, setRows] = useState<ResearchContract[]>([]);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch("/api/research-contracts/catalog", { headers: { Authorization: "Bearer " + token } })
      .then(async (response) => {
        if (!response.ok) throw new Error("Не удалось загрузить исследовательские контракты");
        setRows((await response.json()) as ResearchContract[]);
      })
      .catch((reason: unknown) => setError(reason instanceof Error ? reason.message : "Ошибка"));
  }, [token]);

  const download = async (candidateId: string, kind: "pine" | "pine-verification" | "pine-automatic") => {
    const response = await fetch("/api/research-contracts/" + encodeURIComponent(candidateId) + "/" + kind, {
      headers: { Authorization: "Bearer " + token },
    });
    if (!response.ok) { setError("Не удалось подготовить файл проверки"); return; }
    const suffix = kind === "pine-verification" ? ".pine-verification.json" : ".pine";
    const body = kind === "pine-verification" ? new Blob([JSON.stringify(await response.json(), null, 2)], { type: "application/json" }) : await response.blob();
    const url = URL.createObjectURL(body);
    const link = document.createElement("a");
    link.href = url; link.download = candidateId + suffix; link.click(); URL.revokeObjectURL(url);
  };

  return <section className="knowledge-overlay"><div className="rules-page">
    <header><div><small>Read-only · исследовательская проверка</small><h1>Исследовательские контракты</h1></div><button onClick={onClose}>Закрыть</button></header>
    <p>Контракты описывают активацию, отмену и исходы только для исторического наблюдения. Они не являются сигналами или торговыми командами.</p>
    {error && <p className="knowledge-error">{error}</p>}
    <div className="rule-list">{rows.map((row) => <article key={row.candidate_id} className="rule-card rule-unknown">
      <header><div><code>{row.candidate_id}</code><h2>{row.rule_id}</h2><small>{row.family_id} · SHA-256 {row.contract_sha256.slice(0, 12)}…</small></div><span className="research-denied">{row.trade_permission}</span></header>
      <p>{row.notice}</p><footer><span>Начало измерения: {row.measurement.entry ?? "не задано"}</span><span>Первичный исход: {row.measurement.primary_outcome ?? "не задан"}</span><button onClick={() => download(row.candidate_id, "pine")}>Скачать Pine-стенд</button>{row.candidate_id === "CAND-TRAJECTORY-RETEST-001" && <button onClick={() => download(row.candidate_id, "pine-automatic")}>Автоматический Pine</button>}<button onClick={() => download(row.candidate_id, "pine-verification")}>Пакет Pine-сверки</button></footer>
    </article>)}</div>
  </div></section>;
}
